import Service from 'react-reservice';

import { TOptionChainData, TOptionExpiration } from '@aqx-core/common/api/option';
import { ESortType } from '@aqx-core/common/utils/sorting/types';

import { ISymbolDetailData } from '../types';
import { EUIOptionSide } from './types';

export type TMappedOptionList = Record<string, TOptionChainData>;

export interface IOptionServiceContext {
  loading?: boolean;
  optionExpirations: TOptionExpiration[];
  optionList: TOptionChainData[];
  mappedOptionList: TMappedOptionList;
  optionExpirationIds: string[];
  selectedOptionExpirationIds: string[];
  optionSortType?: ESortType;
  optionSide?: EUIOptionSide;
  underlyingSymbolId?: string;
  underlyingSymbolDetail?: Partial<ISymbolDetailData>;
  underlyingSymbolLoading: boolean;
}

const defaultContext: IOptionServiceContext = {
  loading: true,
  optionExpirations: [],
  optionList: [],
  mappedOptionList: {},
  optionExpirationIds: [],
  selectedOptionExpirationIds: [],
  optionSortType: ESortType.ASC,
  optionSide: EUIOptionSide.ALL,
  underlyingSymbolLoading: false
};

class OptionService extends Service<IOptionServiceContext> {
  constructor() {
    super();

    this.context = defaultContext;
  }

  setLoading = (loading: boolean) => {
    this.context.loading = loading;
  };

  setUnderlyingSymbolId = (underlyingSymbolId: string) => {
    this.context.underlyingSymbolId = underlyingSymbolId;
  };

  setUnderlyingSymbolDetail = (underlyingSymbolDetail: Partial<ISymbolDetailData>) => {
    this.context.underlyingSymbolDetail = underlyingSymbolDetail;
  };

  setUnderlyingSymbolLoading = (loading: boolean) => {
    this.context.underlyingSymbolLoading = loading;
  };

  /** Another method using object key */
  setMappedOptionList = (nextMappedOptionList: TMappedOptionList) => {
    this.context.mappedOptionList = { ...nextMappedOptionList };
  };

  setOptionExpirationIds = (nextOptionExpirationIds: string[]) => {
    this.context.optionExpirationIds = [...nextOptionExpirationIds];
  };

  setSelectedOptionExpirationIds = (nextSelectedOptionExpirationIds: string[]) => {
    this.context.selectedOptionExpirationIds = [...nextSelectedOptionExpirationIds];
  };

  setOptionSortType = (nextOptionSortType: ESortType) => {
    this.context.optionSortType = nextOptionSortType;
  };

  setOptionSide = (nextOptionSide: EUIOptionSide) => {
    this.context.optionSide = nextOptionSide;
  };
}

export const optionService = new OptionService();
